import React from 'react';
import { Column } from 'react-table';
import SessionTable, {
  ResponseGuard,
  SessionTableInstanceProps
} from '../index';
import {
  MappingCell,
  YesNoCell,
  CellFunction,
  RESPONSE_NONE
} from '../../cells';
import {
  IEpxBreastFeed,
  QuestionMeta
} from '../../../../../libs/apps/epxbreastfeed';

const ISSUES_BY_ID = {
  1: 'Inadequate Breastmilk',
  2: 'Latching Issues/Breast Pain',
  3: 'Child Underweight'
};

const QuestionCell: CellFunction<IEpxBreastFeed> = ({
  row: { original: session }
}) => {
  const responses = session.questions as QuestionMeta[];
  const issues: string[] = [];
  let label: React.ReactNode = RESPONSE_NONE;
  if (responses?.length) {
    label = 'None';
    for (let i = 0; i < responses.length; i++) {
      const meta: QuestionMeta = responses[i];
      if (meta.hasIssue) {
        issues.push(ISSUES_BY_ID[meta.id]);
      }
    }
  }
  if (issues.length > 0) {
    label = issues.join(', ');
  }
  return <span>{label}</span>;
};

const EpxBreastFeedTable: React.FC<SessionTableInstanceProps> = (
  props
): JSX.Element => {
  const columns: Column<IEpxBreastFeed>[] = [
    {
      Header: 'Breastfeeding',
      id: 'breastfeeding',
      Cell: ResponseGuard(
        MappingCell('breastfeeding', {
          A: 'Breast Milk Only',
          S: 'Breast Milk and Formula',
          N: 'Formula Only'
        }) as CellFunction<IEpxBreastFeed>
      )
    },
    {
      Header: 'Other Issues',
      id: 'questions',
      Cell: ResponseGuard(QuestionCell)
    },
    {
      Header: 'Spoke to Provider',
      id: 'spokeToDoctor',
      Cell: ResponseGuard(
        YesNoCell('spokeToDoctor') as CellFunction<IEpxBreastFeed>
      )
    }
  ];
  return (
    <SessionTable<IEpxBreastFeed>
      url="/epxbreastfeed/data/"
      columns={columns}
      {...props}
    />
  );
};

export default EpxBreastFeedTable;
